<template>
  <loading :active="showImageEditorLoading"
          :can-cancel="true"
          :on-cancel="onCancel"
          :is-full-page="false"
          :color="'#fff'"
          :background-color="'#000'"
          :opacity="'0.8'"
          :loader=" dots">
  </loading>
  <div style="margin: -20px 8px 0px 25px; height: 700px; ">
    <div class="grid grid-cols-8">
      <div style="height: 680px; margin-right: 15px; ">
        <div
          class="flex text-center items-center justify-center text-md text-black border border-gray-300 cursor-pointer hover:bg-blue-700 hover:text-white h-16"
          :class="{ 'bg-blue-700 text-white': useLabel == 0 }"
          style="margin: 0px;"
          @click="useLabel = 0"
        >
          尺寸
        </div>
        <div
          class="flex text-center items-center justify-center text-md text-black border-gray-300 cursor-pointer hover:bg-blue-700 hover:text-white h-16"
          :class="{ 'bg-blue-700 text-white': useLabel == 1 }"
          style="border-left-width: 1px; border-right-width: 1px; border-bottom-width: 1px; margin: 0px;"
          @click="useLabel = 1"
        >
          組圖生成
        </div>
        <div
          v-show="false"
          class="flex text-center items-center justify-center text-md text-black border-gray-300 cursor-pointer hover:bg-blue-700 hover:text-white h-16"
          :class="{ 'bg-blue-700 text-white': useLabel == 2 }"
          style="border-left-width: 1px; border-right-width: 1px; border-bottom-width: 1px; margin: 0px;"
          @click="useLabel = 2"
        >
          背景生成
        </div>
        <div
          class="flex text-center items-center justify-center text-md text-black border-gray-300 cursor-pointer hover:bg-blue-700 hover:text-white h-16"
          :class="{ 'bg-blue-700 text-white': useLabel == 3 }"
          style="border-left-width: 1px; border-right-width: 1px; border-bottom-width: 1px; margin: 0px;"
          @click="useLabel = 3"
        >
          排版
        </div>
        <div
          class="border py-4 px-2"
          style="margin:10px 0px 0px 0px; height: 415px;"
        >
          <div class="text-sm w-full" style="margin:0px;">直接套用</div>
          <div class="text-xs text-gray-400" style="margin:0px;">使用已設定的樣式</div>
          <div class="overflow-y-auto scrollbar" style="height: 330px;">
            <div class="flex flex-col items-center">
              <template v-for="(itam, index) in apply_list" :key="itam.index">
                <img :src="itam.src" loading="lazy" :alt="itam.title" class="cursor-pointer my-3 border" :title="itam.title" width="90" height="90" @click="pushImg(index, 'apply_list')">
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="border border-gray-300 mx-1.5 col-span-5" style="height: 680px;">
        <div
          ref="container"
          class="flex justify-center bg-gray-500 relative"
          style="height: 530px; margin: 0px;"
          :style="useLabel == 1 ? { height: '530px', borderBottomWidth: '1px' } : { height: '530px' }"
        >
          <div class="canvas-container" style="margin: 5px 0px 0px 0px;">
            <canvas ref="canvas" id="canvas" class="relative" style="z-index: 1;"></canvas>
          </div>
          <div
            class="absolute top-0 bg-white z-0"
            style="margin: 0px 0px 0px 2px; top: 4px; left: 8.25rem; right: 8.25rem; bottom: 0.75rem;"
          ></div>
        </div>
        <div v-show="useLabel == 1" style="height: 150px; padding: 0px 50px;">
          <div class="bottom-container scrollbar" style="margin-top:-10px;">
            <template v-for="(itam, index) in build_background_list" :key="itam.index">
              <span class="image-wrapper">
                <!-- <img :src="itam.src" loading="lazy" class="cursor-pointer" :alt="itam.title" :title="itam.title" width="110" height="110" @click="pushImg(index, 'build_background_list')"> -->
                <img :src="itam.src" loading="lazy" class="cursor-pointer" :alt="itam.title" :title="itam.title" width="110" height="110" @click="getEditImg(index)">
              </span>
            </template>
          </div>
        </div>
        <div v-show="useLabel != 1" class="bg-gray-500" style="height: 150px; margin: 0px;"></div>
      </div>
      <div class="border border-gray-300 col-span-2 overflow-y-auto scrollbar" style="height: 680px;  margin-left: 15px;">
        <div v-if="useLabel == 0">
          <div class="border bg-blue-700 text-white rounded-md py-2 px-4" style="margin: 10px;">
            <span>1：1</span>
            <span class="float-right">1024 x 1024</span>
          </div>
          <div v-show="false" @click="testPosition">測試指定位置</div>
        </div>
        <div v-if="useLabel == 1">
          <span class="text-xs mx-3">商品名稱</span>
          <input
            class="w-full px-3 mx-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
            type="text"
            v-model="productName"
          />
          <span class="text-xs mx-3">商品類別</span>
          <input
            class="w-full px-3 mx-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
            type="text"
            v-model="productClass"
          />
          <span class="text-xs mx-3">商品特徵描述</span>
          <Textarea v-model="productDescription" autoResize="false" class="w-11/12 custom-textarea scrollbar mx-3" rows="3" />
          <div class="bg-gray-100 flex flex-col  text-center items-center justify-center rounded-md h-40" style="margin: 10px;" @click="triggerProductFileUpload">
            <i class="pi pi-cloud-upload mb-2"></i>
            <div v-if="productFileName == null || productFileName == ''" style="margin: 0px;">上傳產品圖</div>
            <div v-if="productFileName == null || productFileName == ''" class="text-sm" style="margin: 0px;">圖片格式：PNG、JPG</div>
            <div v-else class="break-all">{{productFileName}}</div>
            <input type="file" ref="uploadProductFile" style="display: none;" accept=".png, .jpg" @change="onProductImageUpload" />
          </div>
          <!-- <div
            v-if="productFileName != null"
            class="flex text-center items-center justify-center text-md text-black border border-gray-300 cursor-pointer hover:bg-blue-700 hover:text-white rounded-md h-10"
            style="margin: 0px 10px 10px 10px;"
            @click="addProductImage"
          > -->
          <div
            v-if="productFileName != null && productName != null && productClass != null && productDescription != null"
            class="flex text-center items-center justify-center text-md text-black border border-gray-300 cursor-pointer hover:bg-blue-700 hover:text-white rounded-md h-10"
            style="margin: 0px 10px 10px 10px;"
            @click="doUploadProductFile"
          >
            <span v-if="generateUploadProduct == 0">生成描述</span>
            <span v-if="generateUploadProduct == 1">生成描述中...</span>
          </div>
          <div
            v-if="uploadListSelectIndex != null"
            class="flex text-center items-center justify-center text-md text-black border border-gray-300 cursor-pointer hover:bg-blue-700 hover:text-white rounded-md h-10"
            style="margin: 0px 10px 10px 10px;"
            @click="pushImg(uploadListSelectIndex, uploadListSelectType)"
          >
            新增至畫布
          </div>
          <div v-if="selectedObjectType == 'Image'" class="flex h-10 bg-red-200 text-red text-center items-center justify-center text-sm text-black cursor-pointer hover:bg-red-700 hover:text-white rounded-md" style="margin: 0px 10px 10px 10px;" @click="deleteObject">
            刪除
          </div>

          <span class="text-xs mx-3">組圖描述（此為自動生成）</span>
          <Textarea v-model="textPrompt" autoResize="false" class="w-11/12 custom-textarea scrollbar mx-3" rows="3" disabled="true" />
          <div class="bg-gray-100 flex flex-col  text-center items-center justify-center rounded-md h-40" style="margin: 5px 10px 10px 10px;">
            <i class="pi pi-cloud-upload mb-2" :class="[generateBackgrounding == 1 ? null : 'cursor-pointer']" @click="triggerBackGroundFileUpload"></i>
            <span v-if="backGroundFileName == null || backGroundFileName == ''" :class="[generateBackgrounding == 1 ? null : 'cursor-pointer']" @click="triggerBackGroundFileUpload">背景參考</span>
            <span v-if="backGroundFileName == null || backGroundFileName == ''" class="text-xs" :class="[generateBackgrounding == 1 ? null : 'cursor-pointer']" @click="triggerBackGroundFileUpload">上傳類似圖片，幫助系統準確生成背景</span>
            <span v-if="backGroundFileName == null || backGroundFileName == ''" class="text-xs" :class="[generateBackgrounding == 1 ? null : 'cursor-pointer']" @click="triggerBackGroundFileUpload">圖片尺寸建議：1024px x 1024px</span>
            <span v-if="backGroundFileName == null || backGroundFileName == ''" class="text-xs" :class="[generateBackgrounding == 1 ? null : 'cursor-pointer']" @click="triggerBackGroundFileUpload">圖片格式：PNG、JPG</span>
            <div v-if="backGroundFileName != null && backGroundFileName != ''" class="break-all" :class="[generateBackgrounding == 1 ? null : 'cursor-pointer']" @click="triggerBackGroundFileUpload">{{backGroundFileName}}</div>
            <input type="file" ref="uploadBackGroundFile" style="display: none;" accept=".png, .jpg" @change="onBackGroundImageUpload" />
            <div v-if="(backGroundFileName != null && backGroundFileName != '') && generateBackgrounding == 0" class="flex bg-gray-200 text-center items-center justify-center text-sm text-black cursor-pointer hover:bg-blue-700 hover:text-white rounded-md border py-0.5 px-3" @click="clearBackGroundFileInput">
              取消選取
            </div>
          </div>
          <div
            v-if="(backGroundFileName != null && textPrompt != null && textPrompt != '') || (textPrompt != null && textPrompt != '')"
            class="flex text-center items-center justify-center text-md border border-gray-300 cursor-pointer rounded-md h-10"
            :class="[generateBackgrounding == 1 ? 'text-gray-500' : 'text-black hover:bg-blue-700 hover:text-white']"
            style="margin: 0px 10px;"
            @click="runTasks"
          >
            <span v-if="generateBackgrounding == 0">生成背景</span>
            <span v-if="generateBackgrounding == 1">生成背景中...</span>
          </div>
          <div
            v-if="isButtonVisible" 
            class="flex text-center items-center justify-center text-md border border-gray-300 cursor-pointer rounded-md h-10"
            :class="[textToPictureing == 1 ? 'text-gray-500' : 'text-black hover:bg-blue-700 hover:text-white']"
            style="margin: 0px 10px;"
            @click="textToPicture"
          >
            <span v-if="textToPictureing == 0">打燈光特效</span>
            <span v-if="textToPictureing == 1">處理燈光特效中...</span>
          </div>
          <div v-show="false" class="text-sm border flex text-left items-center justify-left h-8 px-2" style="margin: 10px 10px 0px 10px;">推薦風格</div>
          <div v-show="false" class="recommend-container p-2 overflow-y-auto scrollbar" style="height: 320px; margin: 0px 10px 10px; border-left-width: 1px; border-right-width: 1px; border-bottom-width: 1px;">
            <template v-for="(itam, index) in systemStyle" :key="itam.index">
              <span class="remove-back-image-wrapper">
                <img :src="itam.src" loading="lazy" :alt="itam.title" :title="itam.title" width="70" height="70" @click="setStyle(index)">
                <div class="text-sm text-center break-all" style="margin-top:-3px;">{{itam.title}}</div>
              </span>
            </template>
          </div>

          <div v-show="false" class="text-sm border flex text-center items-center justify-center h-8" style="margin:0px 10px;">已上傳</div>
          <div v-show="false" class="upload-container p-2 overflow-y-auto scrollbar" style="margin: 0px 10px 10px 10px; border-left-width: 1px; border-right-width: 1px; border-bottom-width: 1px; height: 180px;">
            <template v-for="(itam, index) in upload_list" :key="itam.index">
              <span class="upload-image-wrapper border">
                <img :src="itam.src" loading="lazy" :alt="itam.title" :title="itam.title" :class="{ 'ring-4 border-blue-400': uploadListSelectIndex == index && uploadListSelectType == 'upload_list' }" width="70" height="70"  @click="selectUpload(index, 'upload_list')">
              </span>
            </template>
          </div>
          <div
            v-if="uploadListSelectIndex != null"
            class="flex text-center items-center justify-center text-md border border-gray-300 cursor-pointer rounded-md h-10"
            :class="[removebacking == 1 ? 'text-gray-500' : 'text-black hover:bg-blue-700 hover:text-white']"
            style="margin: 0px 10px;"
            @click="removeback"
          >
            <span v-if="removebacking == 0">去除背景</span>
            <span v-if="removebacking == 1">去除背景中...</span>
          </div>
          <div v-show="false" class="text-sm border flex text-center items-center justify-center h-8" style="margin: 10px 10px 0px 10px;">已去背</div>
          <div v-show="false" class="remove-back-container p-2 overflow-y-auto scrollbar" style="margin: 0px 10px 10px 10px; border-left-width: 1px; border-right-width: 1px; border-bottom-width: 1px; height: 180px;">
            <template v-for="(itam, index) in remove_back_list" :key="itam.index">
              <span class="remove-back-image-wrapper border">
                <img v-if="false" :src="itam.src" :alt="itam.title" :title="itam.title" width="70" height="70" @click="pushImg(index, 'remove_back_list')">
                <img :src="itam.src" loading="lazy" :alt="itam.title" :title="itam.title" width="70" height="70" :class="{ 'ring-4 border-blue-400': uploadListSelectIndex == index && uploadListSelectType == 'remove_back_list'}" @click="selectUpload(index, 'remove_back_list')">
              </span>
            </template>
          </div>
        </div>
        <div v-if="useLabel == 2">

        </div>
        <div v-if="useLabel == 3">
          <div style="margin: 10px;">
            <span v-if="selectedObjectType != 'Image'" class="text-white block p-2" style="background-color: #5F5F5F;">
              文字內容
              <Textarea id="textContent" v-model="textContent" class="w-full text-white" style="background-color: #5F5F5F; overflow-y: auto;" rows="2"  @keyup="updateTextContent"/>
              <!-- <input type="text" id="textContent" class="w-2/3 text-white" style="background-color: #5F5F5F;" v-model="textContent" @input="updateText" /> -->
            </span>
            <div v-if="selectedObjectType != 'Image'">
              <select id="textFontFamily" class="w-full border h-8" v-model="fontFamily" @change="updateText">
                <option value="Arial">Arial</option>
                <option value="Courier New">Courier New</option>
                <option value="Georgia">Georgia</option>
                <option value="Times New Roman">Times New Roman</option>
                <option value="Verdana">Verdana</option>
                <option value="Noto Serif TC">思源宋體</option>
                <option value="Noto Sans TC">思源黑體</option>
              </select>
            </div>
            <div v-if="selectedObjectType != 'Image'" class="grid grid-cols-2 gap-2">
              <select id="textFontWeight" class="border h-8" v-model="fontWeight" @change="updateText">
                <option value="normal">Normal</option>
                <option value="900">Black</option>
              </select>
              <input type="number" id="textFontSize" class="border h-8" v-model.number="fontSize" @input="updateText" />
            </div>
            <div v-if="selectedObjectType != 'Image'" class="grid grid-cols-2 gap-2">
              <div>
                文字顏色
                <input type="color" id="textColor" class="w-full border h-8" v-model="color" @input="updateText" />
              </div>
              <div>
                邊框顏色
                <input type="color" id="textStrokeColor" class="w-full border h-8" v-model="strokeColor" @input="updateText" />
              </div>
            </div>
            <div v-if="selectedObjectType == 'None'" class="flex h-10 bg-gray-200 text-center items-center justify-center text-sm text-black cursor-pointer hover:bg-blue-700 hover:text-white" @click="addText">
              新增文字
            </div>
            <span v-if="selectedObjectType == 'Image'" class="text-white block p-2 mb-2" style="background-color: #5F5F5F;">
              產品圖
            </span>
            <div v-if="false" class="grid grid-cols-2 gap-2" style="margin:0px;">
              <div class="flex h-10 bg-gray-200 text-center items-center justify-center text-sm text-black cursor-pointer hover:bg-blue-700 hover:text-white" style="margin:0px;" @click="scaleUp">
                放大
              </div>
              <div class="flex h-10 bg-gray-200 text-center items-center justify-center text-sm text-black cursor-pointer hover:bg-blue-700 hover:text-white" style="margin:0px;" @click="scaleDown">
                縮小
              </div>
              <div class="flex h-10 bg-gray-200 text-center items-center justify-center text-sm text-black cursor-pointer hover:bg-blue-700 hover:text-white" style="margin:0px;" @click="rotateLeft">
                向左轉
              </div>
              <div class="flex h-10 bg-gray-200 text-center items-center justify-center text-sm text-black cursor-pointer hover:bg-blue-700 hover:text-white" style="margin:0px;" @click="rotateRight">
                向右轉
              </div>
            </div>
            <div v-if="selectedObjectType != 'None'" class="grid grid-cols-2 gap-2" style="margin:0px;">
              <div class="flex h-10 bg-gray-200 text-center items-center justify-center text-sm text-black cursor-pointer hover:bg-blue-700 hover:text-white" style="margin:0px;" @click="bringToFront">
                最上層
              </div>
              <div class="flex h-10 bg-gray-200 text-center items-center justify-center text-sm text-black cursor-pointer hover:bg-blue-700 hover:text-white" style="margin:0px;" @click="bringForward">
                上一層
              </div>
              <div class="flex h-10 bg-gray-200 text-center items-center justify-center text-sm text-black cursor-pointer hover:bg-blue-700 hover:text-white" style="margin:0px;" @click="sendBackwards">
                下一層
              </div>
              <div class="flex h-10 bg-gray-200 text-center items-center justify-center text-sm text-black cursor-pointer hover:bg-blue-700 hover:text-white" style="margin:0px;" @click="sendToBack">
                最下層
              </div>
            </div>
            <div v-if="selectedObjectType == 'Image' && selectedObjectDetailedType == 'BackGround'" class="flex h-10 bg-gray-200 text-center items-center justify-center text-sm text-black cursor-pointer hover:bg-blue-700 hover:text-white" @click="alignCenter">
              置中對齊
            </div>
            <div class="grid grid-cols-3 gap-2" style="margin:0px;">
              <div class="flex h-16 bg-gray-200 text-center items-center justify-center text-sm text-black cursor-pointer hover:bg-blue-700 hover:text-white" @click="flipHorizontal">
                左右翻轉
              </div>
              <div class="flex h-16 bg-gray-200 text-center items-center justify-center text-sm text-black cursor-pointer hover:bg-blue-700 hover:text-white" @click="flipVertical">
                垂置翻轉
              </div>
              <div class="flex h-16 bg-gray-200 text-center items-center justify-center text-sm text-black cursor-pointer hover:bg-blue-700 hover:text-white" @click="duplicateObject">
                複製
              </div>
            </div>
            <div v-if="selectedObjectType != 'None'" class="flex h-10 bg-red-200 text-red text-center items-center justify-center text-sm text-black cursor-pointer hover:bg-red-700 hover:text-white" style="margin:0px;" @click="deleteObject">
              刪除
            </div>
            <div v-if="selectedObjectType == 'Image'" class="flex h-10 bg-gray-200 text-center items-center justify-center text-sm text-black cursor-pointer hover:bg-blue-700 hover:text-white" @click="showText">
              新增文字
            </div>
          </div>
          <div v-if="false">
            <div>
              <h3>Text Editor</h3>
              <!-- <label for="textFontSize">Font Size:</label>
              <input type="number" id="textFontSize" v-model.number="fontSize" @input="updateText" /> -->

              <!-- <label for="textFontFamily">Font Family:</label>
              <select id="textFontFamily" v-model="fontFamily" @change="updateText">
                <option value="Arial">Arial</option>
                <option value="Courier New">Courier New</option>
                <option value="Georgia">Georgia</option>
                <option value="Times New Roman">Times New Roman</option>
                <option value="Verdana">Verdana</option>
              </select> -->

              <!-- <label for="textColor">Color:</label>
              <input type="color" id="textColor" v-model="color" @input="updateText" /> -->

              <!-- <label for="textContent">Text Content:</label>
              <input type="text" id="textContent" v-model="textContent" @input="updateText" /> -->

              <!-- <label for="textFontWeight">Font Weight:</label>
              <select id="textFontWeight" v-model="fontWeight" @change="updateText">
                <option value="normal">Normal</option>
                <option value="bold">Bold</option>
                <option value="900">Black</option>
              </select> -->

              <!-- <label for="textFontStyle">Font Style:</label>
              <select id="textFontStyle" v-model="fontStyle" @change="updateText">
                <option value="normal">Normal</option>
                <option value="italic">Italic</option>
              </select> -->

              <!-- <label for="textStrokeColor">Stroke Color:</label>
              <input type="color" id="textStrokeColor" v-model="strokeColor" @input="updateText" /> -->

              <!-- <button @click="duplicateObject">复制对象</button> -->

              <!-- <button @click="addText">Add Text</button> -->
            </div>
            <!-- <div>
              <button @click="deleteObject">Delete Selected Object</button>
            </div> -->
            <!-- <div>
              <h3>Image Editor</h3>
              <input type="file" @change="onImageUpload" />
              <button @click="addImage">Add Image</button>
            </div> -->
            <!-- <div>
              <h3>Transform Controls</h3>
              <button @click="scaleUp">Scale Up</button>
              <button @click="scaleDown">Scale Down</button>
              <button @click="rotateLeft">Rotate Left</button>
              <button @click="rotateRight">Rotate Right</button>
              <button @click="flipHorizontal">Flip Horizontal</button>
              <button @click="flipVertical">Flip Vertical</button>
            </div> -->
            <!-- <div>
              <button @click="saveCanvas">Save Image</button>
              <button @click="uploadCanvas">Upload Image</button>
            </div> -->
          </div>
          <!-- <p>Selected Object Type: <span>{{ selectedObjectType }} - {{selectedObjectDetailedType}}</span></p> -->
        </div>
      </div>
    </div>
  </div>
  <Dialog v-model:visible="isDialogVisible" class="w-1/2 bg-white shadow rounded-xl" position="top" :modal="true" :draggable="false" style="position:relative" :closable="false">
    <template #header>
      <div class="w-full p-3 rounded-xl text-white" style="background-color:#2563EB;">
        <div class="text-xl px-3">
          燈光特效
          <button
            class="text-sm border border-white hover:bg-white hover:text-blue-700 rounded-md px-4 py-1 ml-4 float-right"
            @click="downloadImage">
            下載
          </button>
          <button
            class="text-sm border border-white hover:bg-white hover:text-blue-700 rounded-md px-4 py-1 ml-4 float-right"
            @click="isDialogVisible = false">
            關閉
          </button>
        </div>
      </div>
    </template>
    <div class="image-container">
      <img :src="imageSrc" alt="顯示圖片" class="dialog-image" />
    </div>
    <template #footer></template>
  </Dialog>
</template>

<script>
import Dialog from 'primevue/dialog';
import Dropdown from 'primevue/dropdown';
import Textarea from 'primevue/textarea';
import { fabric } from 'fabric';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'
import Loading from 'vue3-loading-overlay';
import axios from 'axios'
import Qs from 'qs'

export default {
  components: {
    Dialog,
    Dropdown,
    Textarea,
    Loading,
  },
  props: {
    toUploadMaterial: {
      type: String
    },
    toDownLoadMaterial: {
      type: String
    },
  },
  data() {
    return {
      canvas: null,
      productName: '跑車模型',
      productClass: '跑車模型',
      productDescription: '黑銀色流線型車身，超低底盤',
      selectedObject: null,
      fontSize: 20,
      fontFamily: 'Arial',
      color: '#000000',
      textContent: 'Hello AutoTurn',
      fontWeight: 'normal',
      fontStyle: 'normal',
      strokeColor: '#000000',
      imageProductFile: null,
      imageBackGroundFile: null,
      useLabel: 0,
      selectedObjectType: 'None',
      selectedObjectDetailedType: 'None',
      apply_list:[],
      build_background_list: [],
      upload_list: [],
      remove_back_list: [],
      textPrompt: '',
      systemStyle: [
        {src: 'https://dev-private.autoturn.net/img/ai_material/style01.jpg', title: '金屬曲線'},
        {src: 'https://dev-private.autoturn.net/img/ai_material/style02.jpg', title: '黑色時尚'},
        {src: 'https://dev-private.autoturn.net/img/ai_material/style03.jpg', title: '明亮舞台'},
        {src: 'https://dev-private.autoturn.net/img/ai_material/style04.jpg', title: '夢幻台階'},
        {src: 'https://dev-private.autoturn.net/img/ai_material/style05.jpg', title: '抽象場景'},
        {src: 'https://dev-private.autoturn.net/img/ai_material/style06.jpg', title: '城市建築'},
        {src: 'https://dev-private.autoturn.net/img/ai_material/style07.jpg', title: '簡約辦公'},
        {src: 'https://dev-private.autoturn.net/img/ai_material/style08.jpg', title: '輕奢衛浴'},
        {src: 'https://dev-private.autoturn.net/img/ai_material/style09.jpg', title: '木質廚房'},
        {src: 'https://dev-private.autoturn.net/img/ai_material/style10.jpg', title: '輕鬆綠意'},
      ],
      uploadListSelectIndex: null,
      uploadListSelectImg: null,
      uploadListSelectType: null,
      productFileName: null,
      productFileUpload: null,
      backGroundFileName: null,
      backGroundSelectImg: null,
      autoProduceBg: null,
      removebacking: 0,
      generateBackgrounding: 0,
      selectedImgForm: null,
      scale: 0.5,
      returnPrompt: [],
      aiUploadRemoveBackReturn : [],
      aiCopyWritingReturn: [],
      aiAdsMasterReturn: [],
      generateUploadProduct: 0,
      materialList: [],
      textToPictureing: 0,
      useImageList: [],
      showImageEditorLoading: false,
      isButtonVisible: false,
      isDialogVisible: false,
      imageSrc: "https://dev-private.autoturn.net/ai_material/background/official/3/2024/09/05/21057ddf-c4ea-489b-a16b-56afcd176ca8.png",
    };
  },
  mounted() {
    this.setCanvasSize();
    window.addEventListener('resize', this.setCanvasSize); // 监听窗口大小变化

    document.fonts.ready.then(() => {
      setTimeout(() => {
        console.log('fonts.ready');
        this.canvas.renderAll();
      }, 500); // 延迟 500 毫秒
    });

    axios
      .post('https://test.autoturn.net/inside/api/ai/ai_upload_list.php', Qs.stringify({
        s_code: this.$route.params.id,
        server: 'dev',
        imgGroup: 'product',
        type: 'tmp'
      }))
      .then((listResponse) => {
        if(listResponse.data.status == 'success'){
          console.log('mounted ai_upload_list tmp');
          console.log(listResponse.data.return_data);
          this.upload_list = listResponse.data.return_data
        }
      });

    axios
      .post('https://test.autoturn.net/inside/api/ai/ai_upload_list.php', Qs.stringify({
        s_code: this.$route.params.id,
        server: 'dev',
        imgGroup: 'product',
        type: 'removebg'
      }))
      .then((listResponse) => {
        if(listResponse.data.status == 'success'){
          console.log('mounted ai_upload_list removebg');
          console.log(listResponse.data.return_data);
          this.remove_back_list = listResponse.data.return_data
        }
      });

    axios
      .post('https://test.autoturn.net/inside/api/ai/ai_upload_list.php', Qs.stringify({
        s_code: this.$route.params.id,
        server: 'dev',
        imgGroup: 'background',
        type: 'official'
      }))
      .then((listResponse) => {
        if(listResponse.data.status == 'success'){
          console.log('mounted ai_upload_list removebg');
          console.log(listResponse.data.return_data);
          this.apply_list = listResponse.data.return_data
        }
      });
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.setCanvasSize); // 移除监听器
  },
  methods: {
    setCanvasSize() {
      console.log('setCanvasSize');
      const container = this.$refs.container;
      const canvas = this.$refs.canvas;

      let width = 1024;//512;//container.clientWidth;
      let height = 1024;//512;//container.clientHeight;
      // if(this.useLabel == 2){
      //   height = 1024;//900;//450;
      // }

      canvas.width = width;
      canvas.height = height;

      console.log(this.canvas);

      if (!this.canvas) {
        console.log('not this.canvas');
        this.initializeCanvas();
      } else {
        console.log('is this.canvas');
        // this.initializeCanvas();

        const objects = this.canvas.getObjects().map(obj => obj);

        this.canvas.clear();
        this.canvas.setWidth(width);
        this.canvas.setHeight(height);
        console.log(width);
        console.log(height);

        this.canvas.setZoom(this.scale);

        objects.forEach(obj => {
          this.canvas.add(obj);
        });

        this.canvas.renderAll();
        console.log('this.canvas');
        console.log(this.canvas);
      }
    },
    adjustMouseEvent(event) {
      // console.log('adjustMouseEvent');
      // console.log(event);
      const pointer = this.canvas.getPointer(event.e);
      pointer.x = pointer.x / this.scale;
      pointer.y = pointer.y / this.scale;
    },
    initializeCanvas() {
      // this.canvas = new fabric.Canvas(this.$refs.canvas);
      this.canvas = new fabric.Canvas(this.$refs.canvas, {
        preserveObjectStacking: true
      });

      this.canvas.on('mouse:down', this.adjustMouseEvent);
      this.canvas.on('mouse:move', this.adjustMouseEvent);
      this.canvas.on('mouse:up', this.adjustMouseEvent);

      this.canvas.on('selection:created', (e) => {
        console.log('selection:created');
        this.selectedObject = e.target;
        this.updateTextFields();
        this.handleObjectSelected(e);
      });

      this.canvas.on('selection:updated', (e) => {
        console.log('selection:updated');
        this.selectedObject = e.target;
        this.updateTextFields();
        this.handleObjectSelected(e);
      });

      this.canvas.on('selection:cleared', (e) => {
        console.log('selection:cleared');
        this.handleObjectSelected(e);
      });

      this.canvas.on('object:modified', (e) => {
        console.log('object:modified');
        this.selectedObject = e.target;
        this.updateTextFields();
      });

      this.canvas.on("object:added", this.checkForBackground);
      this.canvas.on("object:removed", this.checkForBackground);

      this.checkForBackground();

      console.log('initializeCanvas this.canvas');
      console.log(this.canvas);
    },
    checkForBackground() {
      console.log('checkForBackground');
      const hasBackground = this.canvas.getObjects().some(obj => obj.purpose === 'BackGround');
      this.isButtonVisible = hasBackground;
    },
    addText() {
      const text = new fabric.Text(this.textContent, {
        left: 100,
        top: 100,
        scaleX: 1,
        scaleY: 1,
        angle: 0,
        fontSize: this.fontSize,
        fontFamily: this.fontFamily,
        fill: this.color,
        fontWeight: this.fontWeight,
        fontStyle: this.fontStyle,
        stroke: this.strokeColor,
        strokeWidth: 1,
        editable: true,
        hasControls: true,
        lockScalingFlip: true, // 禁止翻转
        lockMovementX: false,
        lockMovementY: false,
        lockScalingX: false,
        lockScalingY: false,
        selectable: true,
        purpose: 'Text',
      }, { crossOrigin: 'anonymous' });

      this.canvas.add(text);
      this.canvas.setZoom(this.scale);
      text.setCoords();  // 计算控制点
      this.canvas.setActiveObject(text);
      this.canvas.on('object:selected', this.handleObjectSelected);
      this.setCanvasSize();

      console.log('Text object:', text);
      console.log('Canvas objects:', this.canvas.getObjects());
    },
    updateTextContent() {
      console.log('updateTextContent');
      console.log(this.textContent);
      // 获取当前选中的对象
      if (this.selectedObject && this.selectedObject.type === 'text') {
        this.selectedObject.set('text', this.textContent);
        this.canvas.renderAll();
      } else {
        console.log('请先选中一个文字对象');
      }
    },
    updateText() {
      if (this.selectedObject && this.selectedObject.type === 'text') {
        this.selectedObject.set({
          fontSize: parseInt(this.fontSize, 10),
          fontFamily: this.fontFamily,
          fill: this.color,
          fontWeight: this.fontWeight,
          fontStyle: this.fontStyle,
          stroke: this.strokeColor,
        });

        this.canvas.renderAll();
      }
    },
    updateTextFields() {
      console.log('updateTextFields');
      if (this.selectedObject && this.selectedObject.type === 'text') {
        this.fontSize = this.selectedObject.fontSize || 20;
        this.fontFamily = this.selectedObject.fontFamily || 'Arial';
        this.color = this.selectedObject.fill || '#000000';
        this.fontWeight = this.selectedObject.fontWeight || 'normal';
        this.fontStyle = this.selectedObject.fontStyle || 'normal';
        this.strokeColor = this.selectedObject.stroke || '#000000';
        this.textContent = this.selectedObject.text || 'Hello, Fabric!';
      }
    },
    triggerProductFileUpload() {
      if(this.removebacking == 0){
        this.$refs.uploadProductFile.click();
      }
    },
    triggerBackGroundFileUpload() {
      if(this.generateBackgrounding == 0){
        this.$refs.uploadBackGroundFile.click();
      }
    },
    onProductImageUpload(event) {
      console.log('onProductImageUpload');
      this.productFileUpload = event.target.files[0];
      console.log(this.productFileUpload);
      const file = event.target.files[0];
      if (file) {
        this.productFileName = file.name;

        const reader = new FileReader();
        console.log('reader');
        console.log(reader);
        reader.onload = (e) => {
          this.imageProductFile = e.target.result;

          console.log('this.imageProductFile');
          console.log(this.imageProductFile);
        };
        reader.readAsDataURL(file);
      }
    },
    onBackGroundImageUpload(event) {
      this.backGroundSelectImg = event.target.files[0];
      const file = event.target.files[0];
      if (file) {
        this.backGroundFileName = file.name;
        this.autoProduceBg = null;

        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageBackGroundFile = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    addProductImage() {
      if (this.imageProductFile) {
        fabric.Image.fromURL(this.imageProductFile, (img) => {
          img.set({
            left: 100,
            top: 100,
            scaleX: 1,
            scaleY: 1,
            angle: 0,
            hasControls: true,
            lockScalingFlip: true, // 禁止翻转
            selectable: true,
            hasBorders: true,
            purpose: 'Product',
          },{
            crossOrigin: 'anonymous'
          });

          this.canvas.add(img);
          this.canvas.setZoom(this.scale);
          img.setCoords();  // 计算控制点
          // this.canvas.setActiveObject(img);
          setTimeout(() => {
            this.canvas.setActiveObject(img);
            this.canvas.renderAll();  // 强制刷新画布

            // 手动调用 handleObjectSelected 并传递刚添加的对象
            this.handleObjectSelected({ target: img });
          }, 50);  // 50ms 的延迟以确保 Fabric.js 处理完成
          this.canvas.on('object:selected', this.handleObjectSelected);
          this.clearProductFileInput();
          this.setCanvasSize();
        });
      }
    },
    addBackGroundImage() {
      if (this.imageBackGroundFile) {
        const canvasCenter = this.canvas.getCenter();

        fabric.Image.fromURL(this.imageBackGroundFile, (img) => {
          img.set({
            left: canvasCenter.left - this.selectedObject.width * this.selectedObject.scaleX / 2,
            top: canvasCenter.top - this.selectedObject.height * this.selectedObject.scaleY / 2,
            scaleX: 1,
            scaleY: 1,
            angle: 0,
            hasControls: true,
            lockScalingFlip: true, // 禁止翻转
            selectable: true,
            hasBorders: true,
            purpose: 'BackGround',
          },{
            crossOrigin: 'anonymous'
          });

          this.canvas.add(img);
          this.canvas.setZoom(this.scale);
          img.setCoords();  // 计算控制点
          // this.canvas.setActiveObject(img);
          setTimeout(() => {
            this.canvas.setActiveObject(img);
            this.canvas.renderAll();  // 强制刷新画布

            // 手动调用 handleObjectSelected 并传递刚添加的对象
            this.handleObjectSelected({ target: img });
          }, 50);  // 50ms 的延迟以确保 Fabric.js 处理完成
          this.canvas.on('object:selected', this.handleObjectSelected);
          this.clearBackGroundFileInput();
          this.setCanvasSize();
        });
      }
    },
    clearProductFileInput() {
      // 清除文件输入框的值
      if(this.$refs.uploadProductFile){
        this.$refs.uploadProductFile.value = null;
      }
      this.productFileName = null;
      this.productFileUpload = null;
    },
    clearBackGroundFileInput() {
      // 清除文件输入框的值
      if(this.$refs.uploadBackGroundFile){
        this.$refs.uploadBackGroundFile.value = null;
      }
      this.backGroundFileName = null;
      this.backGroundSelectImg = null;
      this.autoProduceBg = null;
    },
    scaleUp() {
      if (this.selectedObject) {
        this.selectedObject.scale(this.selectedObject.scaleX * 1.1);
        this.canvas.renderAll();
      }
    },
    scaleDown() {
      if (this.selectedObject) {
        this.selectedObject.scale(this.selectedObject.scaleX * 0.9);
        this.canvas.renderAll();
      }
    },
    rotateLeft() {
      if (this.selectedObject) {
        this.selectedObject.rotate(this.selectedObject.angle - 15);
        this.canvas.renderAll();
      }
    },
    rotateRight() {
      if (this.selectedObject) {
        this.selectedObject.rotate(this.selectedObject.angle + 15);
        this.canvas.renderAll();
      }
    },
    flipHorizontal() {
      if (this.selectedObject) {
        this.selectedObject.set('flipX', !this.selectedObject.flipX);
        this.canvas.renderAll();
      }
    },
    flipVertical() {
      if (this.selectedObject) {
        this.selectedObject.set('flipY', !this.selectedObject.flipY);
        this.canvas.renderAll();
      }
    },
    deleteObject() {
      console.log('deleteObject');
      console.log(this.selectedObject);
      if (this.selectedObject) {
        this.canvas.remove(this.selectedObject);
        this.canvas.discardActiveObject();
        this.canvas.renderAll();
        this.selectedObjectType = 'None';
      }
    },
    saveCanvas() {
      const originalZoom = this.canvas.getZoom();
      this.canvas.setZoom(1);

      const dataURL = this.canvas.toDataURL({
        format: 'png',
        quality: 1.0,
        width: 1024,
        height: 1024,
        crossOrigin: 'Anonymous',
        multiplier: 1, // 由于 canvas 缩放了 0.5，使用 multiplier 还原到实际大小
      });

      this.canvas.setZoom(originalZoom);

      var todayForm = new Date();
      var yearForm = todayForm.getFullYear();
      var dateForm = String(todayForm.getDate()).padStart(2, '0');
      var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
      var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

      let get_value = yearForm + monthForm + dateForm + timeForm;

      const link = document.createElement('a');
      link.href = dataURL;
      link.download = 'autoturn_ai_material_'+get_value+'.png';
      link.click();
    },
    dataURLtoBlob(dataURL) {
      const byteString = atob(dataURL.split(',')[1]);
      const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ab], { type: mimeString });
    },
    uploadCanvas() {
      const originalZoom = this.canvas.getZoom();
      this.canvas.setZoom(1);

      const dataURL = this.canvas.toDataURL({
        format: 'png',
        quality: 1.0,
        width: 1024,
        height: 1024,
        crossOrigin: 'Anonymous',
        multiplier: 1, // 由于 canvas 缩放了 0.5，使用 multiplier 还原到实际大小
      });

      this.canvas.setZoom(originalZoom);

      var todayForm = new Date();
      var yearForm = todayForm.getFullYear();
      var dateForm = String(todayForm.getDate()).padStart(2, '0');
      var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
      var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

      let get_value = yearForm + monthForm + dateForm + timeForm;

      const blob = this.dataURLtoBlob(dataURL);
      const formData = new FormData();
      formData.append('file', blob, 'autoturn_ai_material_'+get_value+'.png');

      fetch('https://test.autoturn.net/inside/api/ai/ai_upload_meta_adaccount.php', {
        method: 'POST',
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          console.log('Success:', data);
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    },
    doUploadProductFile() {
      if (!this.productFileUpload) {
        Swal.fire(
          '廣告素材-AI生成器-上傳產品圖',
          '請選擇一張要上傳的圖片',
          "warning"
        );
        return;
      }

      if(this.generateUploadProduct == 0){
        if (this.productFileUpload) {
          // 检查 MIME 类型
          const mimeType = this.productFileUpload.type;
          console.log('mimeType');
          console.log(mimeType);
          if (mimeType === 'image/png' || mimeType === 'image/jpeg') {
            let formData = new FormData();
            formData.append('productName', this.productName);
            formData.append('productClass', this.productClass);
            formData.append('productDescription', this.productDescription);
            formData.append('image', this.productFileUpload);
            formData.append('s_code', this.$route.params.id);

            this.generateUploadProduct = 1;
            this.showImageEditorLoading = true;

            // axios
            //   .post('https://test.autoturn.net/inside/api/ai/ai_upload_remove_back_dev_01.php', formData, {
            //     headers: {
            //       'Content-Type': 'multipart/form-data'
            //     }
            //   })
            //   .then((response) => {
            //     console.log('ai_upload_remove_back_dev_01 response');
            //     console.log(response);
            //     this.aiUploadRemoveBackReturn = response.data.return_data;
            //     console.log(this.aiUploadRemoveBackReturn);
            //     // if(response.data.status == 'success'){
            //     //   Swal.fire(
            //     //     '廣告素材-AI生成器-去除背景',
            //     //     '去背完畢。',
            //     //     "success"
            //     //   );

            //     //   axios
            //     //     .post('https://test.autoturn.net/inside/api/ai/ai_upload_list.php', Qs.stringify({
            //     //       s_code: this.$route.params.id,
            //     //       server: 'dev',
            //     //       imgGroup: 'product',
            //     //       type: 'removebg'
            //     //     }))
            //     //     .then((listResponse) => {
            //     //       if(listResponse.data.status == 'success'){
            //     //         console.log('removeback ai_upload_list removebg');
            //     //         console.log(listResponse.data.return_data);
            //     //         this.remove_back_list = listResponse.data.return_data
            //     //       }

            //     //       this.removebacking = 0;
            //     //     });
            //     // } else {
            //     //   Swal.fire(
            //     //     '廣告素材-AI生成器-去除背景',
            //     //     response.data.info,
            //     //     "error"
            //     //   );
            //     // }
            //   });

            // axios
            //   .post('https://test.autoturn.net/inside/api/ai/ai_copy_writing_dev_01.php', formData, {
            //     headers: {
            //       'Content-Type': 'multipart/form-data'
            //     }
            //   })
            //   .then((response) => {
            //     console.log('ai_copy_writing_dev_01 response');
            //     console.log(response);
            //     if(response.data.status == 'success'){

            //       this.aiCopyWritingReturn = response.data.return_data;
            //       console.log(this.aiCopyWritingReturn);
            //       // Swal.fire(
            //       //   '廣告素材-AI生成器-生成描述',
            //       //   '生成完成。',
            //       //   "success"
            //       // );

            //       // let returnData = response.data.return_data;
            //       // returnData.forEach(item => this.textPrompt += item + '\r\n\r\n');

            //       // axios
            //       //   .post('https://test.autoturn.net/inside/api/ai/ai_upload_list.php', Qs.stringify({
            //       //     s_code: this.$route.params.id,
            //       //     server: 'dev',
            //       //     imgGroup: 'product',
            //       //     type: 'tmp'
            //       //   }))
            //       //   .then((listResponse) => {
            //       //     this.clearProductFileInput();
            //       //     if(listResponse.data.status == 'success'){
            //       //       // console.log('posts_data');
            //       //       // console.log(listResponse.data.return_data);
            //       //       this.upload_list = listResponse.data.return_data
            //       //     }
            //       //   });
            //     } else {
            //       // Swal.fire(
            //       //   '廣告素材-AI生成器-生成描述',
            //       //   '生成失敗。',
            //       //   "error"
            //       // );
            //     }
            //   })
            //   .catch((error) => {
            //     console.error('Upload request error:', error);
            //   });

            axios
              .post('https://test.autoturn.net/inside/api/ai/ai_background_prompt_generate_dev_01.php', formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              })
              .then((response) => {
                console.log('ai_background_prompt_generate_dev_01 response');
                console.log(response);
                if(response.data.status == 'success'){

                  Swal.fire(
                    '廣告素材-AI生成器-生成描述',
                    '生成完成。',
                    "success"
                  );

                  let returnData = response.data.return_data;
                  returnData.forEach(item => this.textPrompt += item + '\r\n\r\n');
                  this.returnPrompt = response.data.return_data;

                  console.log('ai_background_prompt_generate_dev_01 this.returnPrompt');
                  console.log(typeof this.returnPrompt);
                  console.log(this.returnPrompt);

                  // axios
                  //   .post('https://test.autoturn.net/inside/api/ai/ai_upload_list.php', Qs.stringify({
                  //     s_code: this.$route.params.id,
                  //     server: 'dev',
                  //     imgGroup: 'product',
                  //     type: 'tmp'
                  //   }))
                  //   .then((listResponse) => {
                  //     this.clearProductFileInput();
                  //     if(listResponse.data.status == 'success'){
                  //       // console.log('posts_data');
                  //       // console.log(listResponse.data.return_data);
                  //       this.upload_list = listResponse.data.return_data
                  //     }
                  //   });
                } else {
                  Swal.fire(
                    '廣告素材-AI生成器-生成描述',
                    '生成失敗。',
                    "error"
                  );
                }

                this.generateUploadProduct = 0;
                this.showImageEditorLoading = false;
              })
              .catch((error) => {
                this.generateUploadProduct = 0;
                this.showImageEditorLoading = false;
                
                console.error('Upload request error:', error);
              });;
          } else {
            Swal.fire(
              '廣告素材-AI生成器-上傳產品圖',
              '僅支援png、jpg格式的圖片。',
              "error"
            );
            this.clearProductFileInput();
          }
        }
      } else {
        Swal.fire(
          '廣告素材-AI生成器-生成描述',
          '描述生成中，請稍候。',
          "info"
        );
        return;
      }
    },
    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async doUploadRemoveBack(){
      // if (!this.productFileUpload) {
      //   Swal.fire(
      //     '廣告素材-AI生成器-上傳產品圖',
      //     '請選擇一張要上傳的圖片',
      //     "warning"
      //   );
      //   return;
      // }

      if (this.productFileUpload) {
        // 检查 MIME 类型
        const mimeType = this.productFileUpload.type;
        console.log('mimeType');
        console.log(mimeType);
        if (mimeType === 'image/png' || mimeType === 'image/jpeg') {
          let formData = new FormData();
          formData.append('productName', this.productName);
          formData.append('productClass', this.productClass);
          formData.append('productDescription', this.productDescription);
          formData.append('image', this.productFileUpload);
          formData.append('s_code', this.$route.params.id);

          axios
            .post('https://test.autoturn.net/inside/api/ai/ai_upload_remove_back_dev_01.php', formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            })
            .then((response) => {
              console.log('ai_upload_remove_back_dev_01 response');
              console.log(response);
              this.aiUploadRemoveBackReturn = response.data.return_data;
              console.log(this.aiUploadRemoveBackReturn);
            });

        } else {
          // Swal.fire(
          //   '廣告素材-AI生成器-上傳產品圖',
          //   '僅支援png、jpg格式的圖片。',
          //   "error"
          // );
          this.clearProductFileInput();
        }
      }
    },
    async doCopyWriting(){
      let formData = new FormData();
      formData.append('productName', this.productName);
      formData.append('productClass', this.productClass);
      formData.append('productDescription', this.productDescription);
      formData.append('s_code', this.$route.params.id);

      axios
        .post('https://test.autoturn.net/inside/api/ai/ai_copy_writing_dev_01.php', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((response) => {
          console.log('ai_copy_writing_dev_01 response');
          console.log(response);
          if(response.data.status == 'success'){

            this.aiCopyWritingReturn = response.data.return_data;
            console.log(this.aiCopyWritingReturn);
            // Swal.fire(
            //   '廣告素材-AI生成器-生成描述',
            //   '生成完成。',
            //   "success"
            // );
          } else {
            // Swal.fire(
            //   '廣告素材-AI生成器-生成描述',
            //   '生成失敗。',
            //   "error"
            // );
          }
        })
        .catch((error) => {
          console.error('Upload request error:', error);
        });
    },
    async doGenerateBackground() {
      let _tmpTextPrompt = this.textPrompt;
      let _tmpBackGroundSelectImg = this.backGroundSelectImg;
      let aiGenerateBackground = 'https://test.autoturn.net/inside/api/ai/ai_generate_background.php';

      if (_tmpTextPrompt != null && _tmpTextPrompt != '' && typeof _tmpTextPrompt != 'undefined') {
        this.build_background_list = []; // 每次请求时先清空背景列表

        let aiAdsAster = 'https://test.autoturn.net/inside/api/ai/ai_ads_master_dev_01.php';

        if(this.returnPrompt.length > 0){
          for (let i = 0; i < this.returnPrompt.length; i++) {
          // for (let i = 0; i < 1; i++) {
            try {
              let formDataBg = new FormData();

              console.log('doGenerateBackground this.returnPrompt['+i+']');
              console.log(this.returnPrompt[i]);

              formDataBg.append('image', this.backGroundSelectImg);
              formDataBg.append('server', 'dev');
              formDataBg.append('prompt', this.returnPrompt[i]);
              formDataBg.append('s_code', this.$route.params.id);

              // 使用 async/await 等待请求完成
              const response = await axios.post(aiAdsAster, formDataBg, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              });

              if (response.data.status === 'success') {
                // 逐个更新背景列表
                console.log('doGenerateBackground response.data');
                console.log(response.data);
                this.aiAdsMasterReturn[i] = response.data.return_data;
                // if(response.data.return_data.length > 0){
                //   this.build_background_list.push(...response.data.return_data);
                // }

                // // 立即显示结果
                // console.log('Updated background list:', this.build_background_list);
              }

              console.log('等2秒');
              await this.delay(2000); // 請求完成後等待 5 秒
            } catch (error) {
              console.error('Error generating background in request', i, error);
            }
          }
        } else {
          Swal.fire(
            '廣告素材-AI生成器-生成背景',
            '沒有組圖描述',
            "warning"
          );
        }

      } else {
        // Swal.fire(
        //   '廣告素材-AI生成器-生成背景',
        //   '請填寫背景描述',
        //   "warning"
        // );
        Swal.fire(
          '廣告素材-AI生成器-生成背景',
          '沒有組圖描述',
          "warning"
        );
      }
    },
    async runTasks() {
      if(this.generateBackgrounding == 0){
        this.generateBackgrounding = 1;
        this.showImageEditorLoading = true;

        const task1 = this.doUploadRemoveBack();
        const task2 = this.doCopyWriting();
        const task3 = this.doGenerateBackground();

        const results = await Promise.all([task1, task2, task3]);
        console.log('All tasks completed:', results);

        await this.afterTasks();
      } else {
        Swal.fire(
          '廣告素材-AI生成器-生成背景',
          '背景生成中，請稍等。',
          "info"
        );
      }
    },
    async afterTasks(){
      console.log('afterTasks');
      console.log('this.aiUploadRemoveBackReturn');
      console.log(this.aiUploadRemoveBackReturn);
      console.log('this.aiCopyWritingReturn');
      console.log(this.aiCopyWritingReturn);
      console.log('this.aiAdsMasterReturn');
      console.log(this.aiAdsMasterReturn);

      console.log('等5秒');
      await this.delay(5000); // 請求完成後等待 5 秒

      // this.build_background_list = [];

      this.materialList = [];

      for (var i = 0; i < this.aiAdsMasterReturn.length; i++) {
      // for (var i = 0; i < 1; i++) {
        let tmpAiCopyWritingReturn = this.aiCopyWritingReturn[i];
        let tmpAiAdsMasterReturn = this.aiAdsMasterReturn[i];

        let formData = new FormData();
        formData.append('index', i);
        formData.append('productName', this.productName);
        formData.append('productClass', this.productClass);
        formData.append('productDescription', this.productDescription);
        formData.append('s_code', this.$route.params.id);
        formData.append('rm_bg_product_img', JSON.stringify(this.aiUploadRemoveBackReturn));
        formData.append('background_img', JSON.stringify(tmpAiAdsMasterReturn));
        formData.append('title', JSON.stringify(tmpAiCopyWritingReturn));
        formData.append('server', 'dev');

        const response = await axios.post('https://test.autoturn.net/inside/api/ai/ai_redraw_img_dev_01.php', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        if (response.data.status === 'success') {
          // 逐个更新背景列表
          console.log('response.data.return_data:', response.data.return_data);
          console.log(response.data.return_data.length);
          console.log(typeof response.data.return_data);

          if (response.data.return_data && typeof response.data.return_data === 'object') {
            // 如果需要直接添加整個 JSON 物件
            if(response.data.image_status == 1){
              console.log('更新中');
              this.build_background_list.push(response.data.return_data);
              this.materialList.push(response.data.useImage);
            }

            // 如果需要擷取特定資料欄
            // let extractedData = response.data.return_data.someKey;
            // this.build_background_list.push(extractedData);
          }

          // // 立即显示结果
          console.log('Updated background list:', this.build_background_list);
        }

        // console.log('等2秒');
        await this.delay(2000); // 請求完成後等待 5 秒
      }

      this.generateBackgrounding = 0;
      this.showImageEditorLoading = false;
      Swal.fire(
        '廣告素材-AI生成器-生成背景',
        '處理完成。',
        "success"
      );

      console.log('Final background list:', this.build_background_list);
    },
    handleObjectSelected(e) {
      console.log('handleObjectSelected');
      console.log(e);
      const selectedObject = e.target;
      let objectType = 'None';
      let objectDetailedType = 'None';

      console.log(selectedObject);
      // console.log(selectedObject.type);

      if (selectedObject) {
        if (selectedObject.type === 'text') {
          objectType = 'Text';
        } else if (selectedObject.type === 'image') {
          objectType = 'Image';
        } else {
          objectType = 'Other';
        }

        if (selectedObject.purpose === 'Product') {
          objectDetailedType = 'Product';
        } else if (selectedObject.purpose === 'BackGround') {
          objectDetailedType = 'BackGround';
        } else {
          objectDetailedType = 'Other';
        }

        // Update the selectedObjectType
        this.selectedObjectType = objectType;
        this.selectedObjectDetailedType = objectDetailedType;
      } else {
        this.selectedObjectType = 'None';
        this.selectedObjectDetailedType =  'None';
        this.selectedObject = null;
      }
    },
    duplicateObject() {
      const activeObject = this.canvas.getActiveObject();
      if (activeObject) {
        activeObject.clone(cloned => {
          cloned.set({
            left: activeObject.left + 20,
            top: activeObject.top + 20
          });
          this.canvas.add(cloned);
          this.canvas.setActiveObject(cloned);
          this.canvas.renderAll();
        });
      }
    },
    sendToBack() {
      const activeObject = this.canvas.getActiveObject();
      if (activeObject) {
        activeObject.sendToBack();
        this.canvas.renderAll();
      }
    },
    alignCenter() {
      if (this.selectedObject) {
        const canvasCenter = this.canvas.getCenter();

        this.selectedObject.set({
          left: canvasCenter.left - this.selectedObject.width * this.selectedObject.scaleX / 2,
          top: canvasCenter.top - this.selectedObject.height * this.selectedObject.scaleY / 2,
        });

        this.selectedObject.setCoords(); // 更新对象的边界框
        this.canvas.renderAll();
      }
    },
    bringToFront() {
      const activeObject = this.canvas.getActiveObject();
      if (activeObject) {
        activeObject.bringToFront();
        this.canvas.renderAll();
      }
    },
    sendBackwards() {
      const activeObject = this.canvas.getActiveObject();
      if (activeObject) {
        activeObject.sendBackwards();
        this.canvas.renderAll();
      }
    },
    bringForward() {
      const activeObject = this.canvas.getActiveObject();
      if (activeObject) {
        activeObject.bringForward();
        this.canvas.renderAll();
      }
    },
    showText(){
      this.selectedObjectType = 'None';
      this.selectedObject = null;
      this.canvas.discardActiveObject();
      this.canvas.renderAll();
    },
    selectUpload(index, type){
      if(this.uploadListSelectIndex != index){
        this.uploadListSelectIndex = index;
        if(type == 'upload_list'){
          this.uploadListSelectImg = this.upload_list[index];
        }
        this.uploadListSelectType = type;
      } else {
        this.uploadListSelectIndex = null;
        this.uploadListSelectImg = null;
        this.uploadListSelectType = null;
      }
    },
    removeback(){
      console.log('removeback');

      if(this.removebacking == 0){
        this.removebacking = 1;
        axios
          .post('https://test.autoturn.net/inside/api/ai/ai_remove_back.php', Qs.stringify({
            s_code: this.$route.params.id,
            server: 'dev',
            image: this.uploadListSelectImg,
          }))
          .then((response) => {
            console.log('response');
            console.log(response);

            if(response.data.status == 'success'){
              Swal.fire(
                '廣告素材-AI生成器-去除背景',
                '去背完畢。',
                "success"
              );

              axios
                .post('https://test.autoturn.net/inside/api/ai/ai_upload_list.php', Qs.stringify({
                  s_code: this.$route.params.id,
                  server: 'dev',
                  imgGroup: 'product',
                  type: 'removebg'
                }))
                .then((listResponse) => {
                  if(listResponse.data.status == 'success'){
                    console.log('removeback ai_upload_list removebg');
                    console.log(listResponse.data.return_data);
                    this.remove_back_list = listResponse.data.return_data
                  }

                  this.removebacking = 0;
                });
            } else {
              Swal.fire(
                '廣告素材-AI生成器-去除背景',
                response.data.info,
                "error"
              );
            }
          });
      }
    },
    pushImg(index, type, setTop, setLeft, setScaleX, setScaleY){
      console.log('pushUloadImg');
      console.log(index);
      console.log(this.upload_list);
      console.log(this.upload_list[index]);

      let _tmpLeft = 100;
      let _tmpTop = 100;
      let _tmpScaleX = 1;
      let _tmpScaleY = 1;
      let _tmpHasControls = true;
      let _tmpHasBorders = true;
      let _tmpImgSrc = null;
      let _tmpPurpose = null;
      switch(type){
        case 'upload_list':
          _tmpLeft = 100;
          _tmpTop = 100;
          _tmpHasControls = true;
          _tmpHasBorders = true;
          _tmpImgSrc = this.upload_list[index].src;
          _tmpPurpose = 'Product';
          break;
        case 'remove_back_list':
          _tmpLeft = 100;
          _tmpTop = 100;
          _tmpHasControls = true;
          _tmpHasBorders = true;
          _tmpImgSrc = this.remove_back_list[index].src;
          _tmpPurpose = 'Product';
          break;
        case 'build_background_list':
          _tmpLeft = 0;
          _tmpTop = 0;
          _tmpHasControls = true;
          _tmpHasBorders = true;
          _tmpImgSrc = this.build_background_list[index].src;
          _tmpPurpose = 'BackGround';
          break;
        case 'apply_list':
          _tmpLeft = 0;
          _tmpTop = 0;
          _tmpHasControls = true;
          _tmpHasBorders = true;
          _tmpImgSrc = this.apply_list[index].src;
          _tmpPurpose = 'BackGround';
          break;
      }

      if(setTop){
        _tmpTop = setTop;
      }

      if(setLeft){
        _tmpLeft = setLeft;
      }

      if(setScaleX){
        _tmpScaleX = setScaleX;
      }

      if(setScaleY){
        _tmpScaleY = setScaleY;
      }

      if(_tmpImgSrc){
        fabric.Image.fromURL(_tmpImgSrc, (img) => {
          img.set({
            left: _tmpLeft,
            top: _tmpTop,
            scaleX: _tmpScaleX,
            scaleY: _tmpScaleX,
            angle: 0,
            hasControls: _tmpHasControls,
            lockScalingFlip: true, // 禁止翻转
            selectable: true,
            hasBorders: _tmpHasBorders,
            purpose: _tmpPurpose,
          },{
            crossOrigin: 'anonymous'
          });

          console.log('_tmpPurpose');
          console.log(_tmpPurpose);
          console.log(this.canvas);

          // this.canvas.add(img);

          if (this.canvas.getObjects().length === 0) {
            // 如果为空，直接新增图片
            console.log('空的');
            this.canvas.add(img);
          } else {
            console.log('有東西');
            // 检查是否有 purpose = 'BackGround' 的对象
            let replaced = false;
            this.canvas.getObjects().forEach((obj) => {
              if (obj.purpose === 'BackGround' && _tmpPurpose == 'BackGround') {
                console.log('有背景');
                this.replaceObjectImage(obj, img);
                replaced = true;
              }
            });

            // 如果没有找到要替换的背景对象，直接添加新图片
            if (!replaced) {
              console.log('沒背景');
              this.canvas.add(img);
            }
          }

          this.canvas.setZoom(this.scale);
          img.setCoords();  // 计算控制点
          // this.canvas.setActiveObject(img);
          setTimeout(() => {
            this.canvas.setActiveObject(img);
            this.canvas.renderAll();  // 强制刷新画布

            // 手动调用 handleObjectSelected 并传递刚添加的对象
            this.handleObjectSelected({ target: img });

            if(_tmpPurpose == 'BackGround'){
              console.log('sendToBack and alignCenter');
              this.sendToBack();
              this.alignCenter();
              this.clearBackGroundFileInput();
            } else {
              this.clearProductFileInput();
            }
          }, 50);  // 50ms 的延迟以确保 Fabric.js 处理完成
          this.canvas.on('object:selected', this.handleObjectSelected);
          this.setCanvasSize();
        });

        if(type == 'upload_list'){
          this.uploadListSelectIndex = null;
        }
      }
    },
    getEditImg(index){
      console.log('getEditImg');
      console.log(index);
      
      let data = this.materialList[index];

      console.log(data);

      this.pushEditImg(data.bg_img.src, 'build_background_list', data.bg_img.position[1], data.bg_img.position[0]);
      this.pushEditImg(data.pd_img.src, 'remove_back_list', data.pd_img.position[1], data.pd_img.position[0]);
      this.pushEditImg(data.wd_img.src, 'text_list', data.wd_img.position[1], data.wd_img.position[0]);
    },
    pushEditImg(src, type, setTop, setLeft, setScaleX, setScaleY){
      console.log('pushEditImg');
      console.log(type);
      console.log(src);
      console.log(setTop);
      console.log(setLeft);

      let _tmpLeft = 100;
      let _tmpTop = 100;
      let _tmpScaleX = 1;
      let _tmpScaleY = 1;
      let _tmpHasControls = true;
      let _tmpHasBorders = true;
      let _tmpImgSrc = null;
      let _tmpPurpose = null;
      let _tmpLockMovementX = false;
      let _tmpLockMovementY = false;
      let _tmpLockScalingX = false;
      let _tmpLockScalingY = false;
      switch(type){
        case 'text_list':
          _tmpLeft = setLeft;
          _tmpTop = setTop;
          _tmpHasControls = true;
          _tmpHasBorders = true;
          _tmpImgSrc = src;
          _tmpPurpose = 'Text';
          break;
        case 'remove_back_list':
          _tmpLeft = setLeft;
          _tmpTop = setTop;
          _tmpHasControls = true;
          _tmpHasBorders = true;
          _tmpImgSrc = src;
          _tmpPurpose = 'Product';
          break;
        case 'build_background_list':
          _tmpLeft = setLeft;
          _tmpTop = setTop;
          _tmpHasControls = false;
          _tmpHasBorders = true;
          _tmpImgSrc = src;
          _tmpPurpose = 'BackGround';
          _tmpLockMovementX = true;
          _tmpLockMovementY = true;
          _tmpLockScalingX = true;
          _tmpLockScalingY = true;
          break;
        case 'apply_list':
      }

      if(setTop){
        _tmpTop = setTop;
      }

      if(setLeft){
        _tmpLeft = setLeft;
      }

      if(setScaleX){
        _tmpScaleX = setScaleX;
      }

      if(setScaleY){
        _tmpScaleY = setScaleY;
      }

      console.log('_tmpTop', _tmpTop);
      console.log('_tmpLeft', _tmpLeft);

      if(_tmpImgSrc){
        fabric.Image.fromURL(_tmpImgSrc, (img) => {
          img.set({
            left: _tmpLeft,
            top: _tmpTop,
            scaleX: _tmpScaleX,
            scaleY: _tmpScaleX,
            angle: 0,
            hasControls: _tmpHasControls,
            lockScalingFlip: true, // 禁止翻转
            selectable: true,
            hasBorders: _tmpHasBorders,
            purpose: _tmpPurpose,
            lockMovementX: _tmpLockMovementX,
            lockMovementY: _tmpLockMovementY,
            lockScalingX: _tmpLockScalingX,
            lockScalingY: _tmpLockScalingY,
          },{
            crossOrigin: 'anonymous'
          });

          console.log('_tmpPurpose');
          console.log(_tmpPurpose);
          console.log(this.canvas);

          // this.canvas.add(img);

          if (this.canvas.getObjects().length === 0) {
            // 如果为空，直接新增图片
            console.log('空的');
            this.canvas.add(img);
          } else {
            console.log('有東西');
            // 检查是否有 purpose = 'BackGround' 的对象
            let replaced = false;
            this.canvas.getObjects().forEach((obj) => {
              if (obj.purpose === 'BackGround' && _tmpPurpose == 'BackGround') {
                console.log('有背景');
                this.replaceObjectImage(obj, img);
                replaced = true;
              }
            });

            // 如果没有找到要替换的背景对象，直接添加新图片
            if (!replaced) {
              console.log('沒背景');
              this.canvas.add(img);
            }
          }

          this.canvas.setZoom(this.scale);
          img.setCoords();  // 计算控制点
          // this.canvas.setActiveObject(img);
          setTimeout(() => {
            this.canvas.setActiveObject(img);
            this.canvas.renderAll();  // 强制刷新画布

            // 手动调用 handleObjectSelected 并传递刚添加的对象
            this.handleObjectSelected({ target: img });

            if(_tmpPurpose == 'BackGround'){
              console.log('sendToBack and alignCenter');
              this.sendToBack();
              this.alignCenter();
              // this.clearBackGroundFileInput();
            } else {
              // this.clearProductFileInput();
            }
          }, 50);  // 50ms 的延迟以确保 Fabric.js 处理完成
          this.canvas.on('object:selected', this.handleObjectSelected);
          this.setCanvasSize();
        });

        if(type == 'upload_list'){
          this.uploadListSelectIndex = null;
        }
      }
    },
    replaceObjectImage(oldObject, newImage) {
      console.log('replaceObjectImage');
      console.log(oldObject);
      console.log(newImage);
      this.canvas.remove(oldObject);
      this.canvas.add(newImage);
      this.canvas.setActiveObject(newImage);
      this.canvas.renderAll();
    },
    replaceObjectByProperty(property, value, newImageObject) {
      console.log('replaceObjectByProperty');
      // 遍历画布上的所有对象
      this.canvas.getObjects().forEach((obj) => {
        // 判断对象的特定属性是否匹配
        if (obj[property] === value) {
          // 如果匹配，替换该对象为新的图像对象
          this.replaceObject(obj, newImageObject);
        }
      });
    },
    replaceObject(oldObject, newImageObject) {
      console.log('replaceObject');
      // 获取旧对象的位置和设置
      const left = oldObject.left;
      const top = oldObject.top;
      const scaleX = oldObject.scaleX;
      const scaleY = oldObject.scaleY;
      const angle = oldObject.angle;

      // 其他你想保留的属性
      const options = {
        hasControls: oldObject.hasControls,
        hasBorders: oldObject.hasBorders,
        lockScalingFlip: oldObject.lockScalingFlip,
        selectable: oldObject.selectable,
        purpose: oldObject.purpose,
      };

      // 设置新图像对象的位置和其他属性
      newImageObject.set({
        left: left,
        top: top,
        scaleX: scaleX,
        scaleY: scaleY,
        angle: angle,
        ...options
      });

      // 从画布中移除旧对象
      this.canvas.remove(oldObject);

      // 将新对象添加到画布
      this.canvas.add(newImageObject);

      // 重新渲染画布
      this.canvas.renderAll();
    },
    setStyle(index){
      console.log('setStyle');
      console.log(index);
      // Swal.fire(
      //   '廣告素材-AI生成器-推薦風格',
      //   '規劃中，敬請期待。',
      //   "info"
      // );
      axios
        .post('https://test.autoturn.net/inside/api/ai/ai_auto_produce_bg.php', Qs.stringify({
          s_code: this.$route.params.id,
          server: 'dev',
          index: index,
        }))
        .then((response) => {
          console.log('response');
          console.log(response);
          this.clearBackGroundFileInput();
          if(response.data.status == 'success'){
            this.textPrompt = response.data.describe;
            this.backGroundFileName = response.data.name;
            this.autoProduceBg = response.data.reference_img;
            // this.build_background_list = response.data.return_data;
          }
        });
    },
    testPosition(){
      console.log('testPosition');

      this.pushImg(0, 'apply_list', 0, 0);
      this.pushImg(1, 'remove_back_list', 50, 50, 1, 1);
      // this.pushImg(2, 'remove_back_list', 200, 250);
      this.pushImg(3, 'remove_back_list', 100, 100, 1, 1);
      this.pushImg(8, 'remove_back_list', 300, 300, 0.5, 0.5);
      // this.pushImg(4, 'remove_back_list', 400, 350);
    },
    async textToPicture() {
      console.log('textToPicture');
      if(this.textToPictureing == 0){
        this.textToPictureing = 1;

        this.useImageList = [];
        const invisibleCanvas = new fabric.Canvas(document.createElement('canvas'));
        const textObjects = this.canvas.getObjects().filter(obj => obj.purpose === 'Text');

        if (textObjects.length === 0) {
          console.warn('No text objects found on canvas.');
          this.lightingSpeEff();
          return;
        }

        const processTextObject = async (textObject, index) => {
          return new Promise(resolve => {
            const { left, top, scaleX, scaleY, text, fontSize, fontFamily, fill } = textObject;

            textObject.clone(clonedText => {
              const originalLeft = clonedText.left;
              const originalTop = clonedText.top;
              const boundingRect = clonedText.getBoundingRect(true);

              clonedText.left = 0;
              clonedText.top = 0;
              clonedText.scaleX = scaleX;
              clonedText.scaleY = scaleY;

              invisibleCanvas.setWidth(boundingRect.width);
              invisibleCanvas.setHeight(boundingRect.height);

              invisibleCanvas.add(clonedText);
              invisibleCanvas.renderAll();

              const dataURL = invisibleCanvas.toDataURL({
                format: 'png',
                quality: 1.0,
                crossOrigin: 'Anonymous',
              });

              const blob = this.dataURLtoBlob(dataURL);

              const todayForm = new Date().toISOString().replace(/[-:.T]/g, '').slice(0, 14);
              const fileName = `text_object_${index + 1}_${todayForm}.png`;

              const data = {
                text,
                fontSize,
                fontFamily,
                color: fill,
                originalLeft,
                originalTop,
                scaleX,
                scaleY,
                image: blob,
                fileName,
                boundingRect,
              };

              invisibleCanvas.clear();
              resolve(data);
            });
          });
        };

        for (let i = 0; i < textObjects.length; i++) {
          const item = await processTextObject(textObjects[i], i);

          const formData = new FormData();
          formData.append('s_code', this.$route.params.id);
          formData.append('file', item.image, item.fileName);
          formData.append('meta', JSON.stringify({
            text: item.text,
            fontSize: item.fontSize,
            fontFamily: item.fontFamily,
            color: item.color,
            originalLeft: item.originalLeft,
            originalTop: item.originalTop,
            scaleX: item.scaleX,
            scaleY: item.scaleY,
          }));

          try {
            const response = await fetch('https://test.autoturn.net/inside/api/ai/ai_upload_text_to_picture.php', {
              method: 'POST',
              body: formData,
            });

            const result = await response.json();
            console.log('Success:', result);

            this.useImageList.push({
              imageUrl: "https://dev-private.autoturn.net/" + result.src,
              left: item.boundingRect.left,
              top: item.boundingRect.top,
              width: item.boundingRect.width,
              height: item.boundingRect.height,
              purpose: "Text",
              text: item.text,
              fontSize: item.fontSize,
              fontFamily: item.fontFamily,
              color: item.color,
              originalLeft: item.originalLeft,
              originalTop: item.originalTop,
              scaleX: item.scaleX,
              scaleY: item.scaleY,
            });
          } catch (error) {
            console.error('Error:', error);
          }
        }

        this.lightingSpeEff();
      } else {
        Swal.fire(
          '廣告素材-AI生成器-燈光特效',
          '特效處理中，請稍等。',
          "info"
        );
      }
    },
    lightingSpeEff(){
      console.log('lightingSpeEff');
      // const objects = this.canvas.getObjects(); // 獲取畫布中的所有對象
      const objects = this.canvas.getObjects().filter(obj => obj.purpose !== 'Text');

      const objectDetails = objects.map((obj, index) => {
        const commonInfo = {
          id: index + 1, // 可選：給物件一個臨時編號（僅作為調試用途）
          left: obj.left,
          top: obj.top,
          width: obj.width,
          height: obj.height,
          scaleX: obj.scaleX,
          scaleY: obj.scaleY,
          actualWidth: obj.width * obj.scaleX, // 實際寬度
          actualHeight: obj.height * obj.scaleY, // 實際高度
          type: obj.type, // 物件類型，例如 'image', 'i-text'
          purpose: obj.purpose || "unknown", // 自定義屬性
        };

        // 判斷類型，添加特定的屬性資訊
        if (obj.purpose === 'Product' || obj.purpose === 'BackGround') {
          this.useImageList.push(
            {
              ...commonInfo,
              imageUrl: obj.getSrc() || "unknown", // 獲取圖片的 URL
            }
          );
        } else if (obj.purpose === 'Text') {
          // return {
          //   ...commonInfo,
          //   text: obj.text || "", // 獲取文字內容
          //   fontSize: obj.fontSize,
          //   fontFamily: obj.fontFamily,
          //   textColor: obj.fill, // 文字顏色
          // };
        } else {
          this.useImageList.push(
            {
              ...commonInfo,
              additionalInfo: "其他類型或未處理的類型",
            }
          );
        }
      });

      this.textToPictureing = 0;
      console.log('this.useImageList', this.useImageList);

      axios
        .post('https://test.autoturn.net/inside/api/ai/ai_api_special_effects.php', Qs.stringify({
          s_code: this.$route.params.id,
          data: this.useImageList,
        }))
        .then((listResponse) => {
          console.log('ai_api_special_effects');
          console.log(listResponse.data.return_data);
          
          if(listResponse.data.status == 'success'){
            
          }

          // this.openDialog();
          this.isDialogVisible = true;
          console.log(this.isDialogVisible);
        });

      // console.log(objectDetails); // 輸出到控制台
      // return objectDetails;
    },
    // 關閉彈出視窗
    closeDialog() {
      console.log('closeDialog');
      this.isDialogVisible = false;
    },
    // 下載圖片功能
    downloadImage() {
      console.log('downloadImage');
      const link = document.createElement("a");
      link.href = this.imageSrc; // 圖片 URL
      link.download = "downloaded-image.png"; // 下載的檔案名稱
      link.click();
    },
  },
  watch: {
    useLabel(value){
      console.log('watch useLabel');
      console.log(value);

      this.setCanvasSize();
    },
    toUploadMaterial(value){
      console.log('watch toUploadMaterial');
      let _tmpStatus = value.split('_');

      if(_tmpStatus[0] == 'true'){
        this.uploadCanvas();
      }
    },
    toDownLoadMaterial(value){
      console.log('watch toDownLoadMaterial');
      let _tmpStatus = value.split('_');

      if(_tmpStatus[0] == 'true'){
        this.saveCanvas();
      }
    }
  },
};
</script>

<style scoped>
/* Add some styling for the inputs if needed */
div {
  margin: 10px 0;
}
label {
  margin-right: 10px;
}
button {
  margin-right: 5px;
}
</style>
<style>
  @font-face {
    font-family: 'Noto Serif TC';
    src: url('https://dev-private.autoturn.net/ttf/NotoSerifTC-VariableFont_wght.ttf') format('truetype');
  }

  @font-face {
    font-family: 'Noto Sans TC';
    src: url('https://dev-private.autoturn.net/ttf/NotoSansTC-VariableFont_wght.ttf') format('truetype');
  }

  .custom-textarea {
    max-height: 150px !important; /* 強制最大高度 */
    overflow-y: auto !important; /* 強制顯示滾動條 */
    resize: none !important;     /* 禁用調整大小 */
  }

  .bottom-container {
    height: 140px; /* 固定高度 */
    display: flex;
    justify-content: space-between; /* 並列顯示並在空白處添加間距 */
    align-items: center; /* 垂直居中對齊圖片 */
    overflow-x: auto; /* 如果圖片超過寬度，顯示橫向捲軸 */
  }
  .image-wrapper {
    width: 110px; /* 設置圖片區塊的寬度 */
    height: 110px; /* 設置圖片區塊的高度 */
    flex-shrink: 0;
  }
  .image-wrapper img {
    width: 100%; /* 讓圖片填滿圖片區塊 */
    height: 100%; /* 讓圖片填滿圖片區塊 */
    /*flex-shrink: 0;*/ /* 防止圖片被縮小 */
    object-fit: cover; /* 保持圖片的寬高比並填滿區塊 */
  }

  .upload-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, 70px); /* 每个图像块宽度为 70px */
    grid-column-gap: 12px; /* 列之间的间距 */
    grid-row-gap: 5px; /* 行之间的间距 */
    /*width: 100%;*/ /* 容器宽度为随机或自动调节 */
    max-width: 100%; /* 确保容器不会超出其父容器的宽度 */
    height: auto; /* 高度根据内容自动调节 */
  }
  .upload-image-wrapper {
    width: 70px; /* 图像块宽度 */
    height: 70px; /* 图像块高度 */
    cursor: pointer;
  }
  .upload-image-wrapper img {
    width: 100%; /* 让图片填满图像块 */
    height: 100%; /* 让图片填满图像块 */
    object-fit: cover; /* 保持图片的宽高比并填满图像块 */
  }

  .remove-back-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, 70px); /* 每个图像块宽度为 70px */
    grid-column-gap: 12px; /* 列之间的间距 */
    grid-row-gap: 5px; /* 行之间的间距 */
    /*width: 100%;*/ /* 容器宽度为随机或自动调节 */
    max-width: 100%; /* 确保容器不会超出其父容器的宽度 */
    height: auto; /* 高度根据内容自动调节 */
  }
  .remove-back-image-wrapper {
    width: 70px; /* 图像块宽度 */
    height: 70px; /* 图像块高度 */
    cursor: pointer;
  }
  .remove-back-image-wrapper img {
    width: 100%; /* 让图片填满图像块 */
    height: 100%; /* 让图片填满图像块 */
    object-fit: cover; /* 保持图片的宽高比并填满图像块 */
  }

  .recommend-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, 70px); /* 每个图像块宽度为 70px */
    grid-column-gap: 12px; /* 列之间的间距 */
    grid-row-gap: 20px; /* 行之间的间距 */
    /*width: 100%;*/ /* 容器宽度为随机或自动调节 */
    max-width: 100%; /* 确保容器不会超出其父容器的宽度 */
    height: auto; /* 高度根据内容自动调节 */
  }
</style>

<style scoped>
.canvas-container {
  width: 512px;
  height: 512px;
  overflow: hidden;
/*  border: 1px solid #ccc;*/
}

/* 将 canvas 元素缩放为 50% */
#canvas {
/*  transform: scale(0.5);*/
  transform-origin: 0 0;
}

@layer utilities {
  /* 滚动条的宽度 */
  .scrollbar::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  /* 滚动条轨道 */
  .scrollbar::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* 滚动条滑块 */
  .scrollbar::-webkit-scrollbar-thumb {
    background-color: #888;
    border-radius: 6px;
    border: 2px solid transparent;
  }

  /* 当鼠标悬停在滚动条上时 */
  .scrollbar::-webkit-scrollbar-thumb:hover {
    background-color: #555;
  }
}

.dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.dialog-content {
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  max-width: 90%; /* 限制視窗寬度 */
  max-height: 90%; /* 限制視窗高度 */
  overflow: auto;
}

.image-container {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  margin-bottom: 20px; /* 與按鈕的間距 */
}

.dialog-image {
  max-width: 50%; /* 圖片最大寬度為容器寬度 */
  max-height: 50%; /* 圖片最大高度為容器高度 */
  object-fit: contain; /* 保持圖片比例不變，並按比例縮小 */
  width: auto; /* 防止圖片拉伸 */
  height: auto; /* 防止圖片拉伸 */
}

.dialog-actions {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.btn {
  padding: 10px 20px;
  background-color: blue;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
.btn:hover {
  background-color: darkblue;
}
.btn-close {
  background-color: red;
}
.btn-close:hover {
  background-color: darkred;
}
</style>